/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */

/**
 *
 * @author Evgenij Tyan
 * @version 1.21.0
 * @since 1.0.0
 */

import { IOptionItemProps } from '@components/common/Select/Select';

export enum ETopicType {
    account = 'ACCOUNT',
    subscriberMobile = 'MOBILE',
}

export enum ETopicAttrDataType {
    BOOL = 'BOOL',
    DATE = 'DATE',
    DB_QUERY = 'DB_QUERY',
    DICTIONARY = 'DICTIONARY',
    NUMBER = 'NUMBER',
    OAPI_VALUE = 'OAPI_VALUE',
    STRING = 'STRING',
}

export enum ETopicAttrVisibility {
    HIDDEN = 'HIDDEN',
    MANDATORY = 'MANDATORY',
    READ_ONLY = 'READ_ONLY',
}

export interface ICreateInquiryReducer {
    attachList: IInquiryAttachProps[];
    inquiryForm: any;
    isLoading: boolean;
    message: string;
    subscriberId?: number;
    topicInfo: ITopicInfo;
    topicList: IOptionItemProps[];
    type?: string;
    userInfo: IInquiryUser;
}

export interface IInquiryAttachProps {
    fileId: number;
    fileName: string;
}

export interface ITopicOptions {
    def: string;
    desc: string;
    href: string;
    id: string;
    lang: number;
    level: number;
    objId1: number;
    sortOrder: number;
    type: number;
}

export interface IInquiryUser {
    account: number;
    clntId: string;
    email: string;
    emailCheckPattern?: string;
    msisdn: string;
    name: string;
    phone: number;
    standardId: number;
    subsId: string;
}

export interface ITopicCustomerRegExp {
    exceptionMessage: string;
    regExpText: string;
    warningMessage: string;
}

export interface ITopicCustomerDeclaration {
    dataType: ETopicAttrDataType;
    multiselect: number;
    regExpRule: ITopicCustomerRegExp;
    visibility: ETopicAttrVisibility;
}

export interface ITopicCustomerAttrValue {
    id: number;
    keyName: string;
    name: string;
    value: string;
}

export interface ITopicCustomerAttr {
    declaration: ITopicCustomerDeclaration;
    dictionaryId?: number;
    id: number;
    key: string;
    name: string;
    optionsList?: IOptionItemProps[];
    valueList: ITopicCustomerAttrValue[];
}

export interface ITopicDictionaryValue {
    id: string;
    keyName: string;
    name: string;
}

export interface ITopicDictionary {
    customAttrId: number;
    name: string;
    values: ITopicDictionaryValue[];
}

export interface ITopicInfo {
    customAttrs: ITopicCustomerAttr[];
    dictionaries: ITopicDictionary[];
    hiddenForFixedService: boolean;
    id: string;
}
